/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { ProposalSplitType } from 'src/enums';
import { useAuth } from 'src/hooks/auth';
import { useQuery } from 'src/hooks/router';
import api from 'src/services/api';
import BackButton from 'src/components/BackButton';
import {
  renderDetailTitle,
  renderFantasyName,
  renderSocialName,
  renderDocument,
  renderStatus,
} from './utils/renderSkeleton';
import {
  DetailsContent,
  BodyDetailsClient,
  Title,
  BodyDetails,
  LeftDetails,
  RightDetails,
  DetailsClient,
  TitleDetailsClient,
} from './styles';
import { IDTO, DataServerDTO } from './utils/interfaces';
import SplitDetails from './components/Split';
import OwnerAssignmentDetails from './components/OwnerAssignment';

const Details: React.FC = () => {
  const { id: idFilter } = useParams<IDTO>();
  const query = useQuery();
  const startDateInterval = query.get('startDateInterval');
  const endDateInterval = query.get('endDateInterval');
  const [dataContract, setDataContract] = useState<DataServerDTO>();
  const [fantasyName, setFantasyName] = useState<string>();
  const [socialName, setSocialName] = useState<string>();
  const [document, setDocument] = useState<string>();
  const { isAuthenticated, selectedMerchant, selectedDocument } = useAuth();

  useEffect(() => {
    if (dataContract) {
      const oppositeMerchant = selectedMerchant?.is_creditor
        ? 'debtor'
        : 'creditor';
      setSocialName(dataContract[oppositeMerchant].legal_name);
      setFantasyName(dataContract[oppositeMerchant].fantasy_name);
      setDocument(dataContract[oppositeMerchant].document);
    }
  }, [dataContract, isAuthenticated, selectedMerchant]);

  useEffect(() => {
    async function findId() {
      const idProposal = idFilter;
      if (idProposal) {
        let url = `/api/v1/merchants/${selectedDocument}/proposals/${idProposal}?include=groups`;
        if (startDateInterval && endDateInterval) {
          url += `&startDateInterval=${startDateInterval}&endDateInterval=${endDateInterval}`;
        }
        const response = await api.get(url);

        if (idFilter && isAuthenticated) setDataContract(response.data);
      }
    }
    findId();
  }, [
    idFilter,
    isAuthenticated,
    selectedDocument,
    selectedMerchant,
    startDateInterval,
    endDateInterval,
  ]);

  return (
    <DetailsContent>
      <Title>
        <span
          style={{
            color: 'var(--color-primary-darker)',
            fontFamily: 'Roboto',
            fontWeight: 500,
          }}
        >
          {`Proposta #${`00000${idFilter}`.slice(-5)}`}
        </span>
        <div
          id="btnBack"
          style={{
            display: 'flex',
            flex: 1,
            height: 1,
            background: 'var(--color-primary-darker)',
            marginRight: 20,
            marginLeft: 20,
          }}
        />
        <BackButton address="/proposals" />
      </Title>
      <BodyDetails>
        <LeftDetails>
          <DetailsClient>
            <TitleDetailsClient>
              {renderDetailTitle(!!selectedMerchant?.is_creditor)}
            </TitleDetailsClient>
            <BodyDetailsClient>
              <span>Nome Fantasia</span>
              {renderFantasyName(fantasyName)}
              <span>Nome Social</span>
              {renderSocialName(socialName)}
              <span>CPF/CNPJ</span>
              {renderDocument(document)}
              <span>Status</span>
              {renderStatus(dataContract)}
            </BodyDetailsClient>
          </DetailsClient>
        </LeftDetails>
        <RightDetails>
          <TitleDetailsClient>Detalhes da Proposta</TitleDetailsClient>
          {dataContract?.split_type ===
          ProposalSplitType.ownership_assignment ? (
            <OwnerAssignmentDetails dataContract={dataContract} />
          ) : (
            <SplitDetails
              dataContract={dataContract}
              setDataContract={setDataContract}
            />
          )}
        </RightDetails>
      </BodyDetails>
    </DetailsContent>
  );
};

export default Details;
